var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "controlParty"
    }
  }, [_c('div', {
    staticClass: "contentLeft"
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('common.validMute'),
      "placement": "top"
    }
  }, [_c('el-button', {
    class: _vm.returnMuteClass,
    attrs: {
      "type": "success",
      "disabled": _vm.judgeMuteButton
    },
    on: {
      "click": function ($event) {
        return _vm.controlMute('mute');
      }
    }
  }, [_vm._v(_vm._s(_vm.leftButtonText))])], 1), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('common.validMute'),
      "placement": "top"
    }
  }, [_c('el-button', {
    class: _vm.returnMuteClass,
    attrs: {
      "type": "success",
      "disabled": _vm.judgeMuteButton
    },
    on: {
      "click": function ($event) {
        return _vm.controlMute('unmute');
      }
    }
  }, [_vm._v(_vm._s(_vm.rightButtonText))])], 1), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('common.validMove'),
      "placement": "top"
    }
  }, [_c('el-button', {
    staticClass: "green",
    class: {
      gray: !_vm.GlobalControlId
    },
    attrs: {
      "type": "success",
      "disabled": !_vm.GlobalControlId
    },
    on: {
      "click": _vm.moveParticipants
    }
  }, [_vm._v(_vm._s(_vm.$t('Movepips.moveTips.save')))])], 1), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t('remainWords.edit'),
      "placement": "top"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.GlobalControlId,
      expression: "GlobalControlId"
    }],
    staticClass: "el-icon-plus pointer",
    on: {
      "click": _vm.showAddGlobalControl
    }
  })]), _c('el-divider', {
    attrs: {
      "direction": "vertical"
    }
  }), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t('common.refreshData'),
      "placement": "top"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.GlobalControlId,
      expression: "GlobalControlId"
    }],
    staticClass: "el-icon-refresh pointer",
    on: {
      "click": _vm.refreshData
    }
  })])], 1), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('el-checkbox', {
    staticClass: "w_5",
    on: {
      "change": val => {
        _vm.dealParticipantListUI({
          type: 'allCheck',
          val
        });
      }
    },
    model: {
      value: _vm.selectAll,
      callback: function ($$v) {
        _vm.selectAll = $$v;
      },
      expression: "selectAll"
    }
  }), _c('span', {
    staticClass: "commonSpan w_10"
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]), _c('span', {
    staticClass: "commonSpan w_10"
  }, [_vm._v(_vm._s(_vm.$t('common.mic')))]), _c('span', {
    staticClass: "commonSpan w_18"
  }, [_vm._v(_vm._s(_vm.$t('common.title')))]), _c('span', {
    staticClass: "commonSpan w_18"
  }, [_vm._v(_vm._s(_vm.$t('galleryHost.output')))]), _c('span', {
    staticClass: "commonSpan w_18"
  }, [_vm._v(_vm._s(_vm.$t('mainWindow.mainW')))]), _c('span', {
    staticClass: "commonSpan w_10"
  }, [_vm._v(_vm._s(_vm.$t('common.remark')))])], 1), _vm.partyList.length ? _c('div', {
    staticClass: "list scrollbar"
  }, [_c('el-collapse', {
    model: {
      value: _vm.partyExpand,
      callback: function ($$v) {
        _vm.partyExpand = $$v;
      },
      expression: "partyExpand"
    }
  }, _vm._l(_vm.partyList, function (item) {
    return _c('el-collapse-item', {
      key: item.id,
      attrs: {
        "name": item.partyCode
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.saveAndGetList(item.partyCode);
        }
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "rowCheckBox",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return (() => {}).apply(null, arguments);
        }
      }
    }, [_c('el-checkbox', {
      staticClass: "w_5",
      on: {
        "change": val => {
          _vm.dealParticipantListUI({
            type: 'rowCheck',
            val,
            partyCode: item.partyCode
          });
        }
      },
      model: {
        value: item.checked,
        callback: function ($$v) {
          _vm.$set(item, "checked", $$v);
        },
        expression: "item.checked"
      }
    })], 1), _c('span', {
      staticClass: "commonSpan w_10"
    }, [_vm._v(_vm._s(item.number))]), _c('span', {
      staticClass: "commonSpan w_10 mic"
    }, [item.microphoneStatus != 1 ? _c('svg', {
      staticClass: "unMuteAudioImg",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-maikefeng-kai"
      }
    })]) : _c('svg', {
      staticClass: "muteAudioImg",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-universal_micoff"
      }
    })])]), _c('span', {
      staticClass: "commonSpan w_18",
      attrs: {
        "title": item.name || item.partyCode
      }
    }, [_vm._v(_vm._s(item.name || item.partyCode))]), _c('span', {
      staticClass: "commonSpan w_18"
    }, [_vm._v(_vm._s(_vm.$t('galleryHost.output')))]), _c('span', {
      staticClass: "commonSpan w_18"
    }, [_vm._v(_vm._s(item.mainWindow))]), _c('span', {
      staticClass: "commonSpan w_10"
    }, [_vm._v(_vm._s(_vm.$t('common.remark')))])]), _c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: item.loading,
        expression: "item.loading"
      }],
      staticClass: "partiBox"
    }, _vm._l(item.participantList, function (info, index) {
      return _c('div', {
        key: info.rtilCode,
        staticClass: "partiRow"
      }, [_c('div', {
        staticClass: "rowPartiCheckBox",
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            return (() => {}).apply(null, arguments);
          }
        }
      }, [_c('el-checkbox', {
        staticClass: "w_5",
        on: {
          "change": val => {
            _vm.dealParticipantListUI({
              type: 'partiRowCheck',
              val,
              partyCode: item.partyCode,
              index
            });
          }
        },
        model: {
          value: info.rowChecked,
          callback: function ($$v) {
            _vm.$set(info, "rowChecked", $$v);
          },
          expression: "info.rowChecked"
        }
      })], 1), _c('el-divider', {
        attrs: {
          "direction": "vertical"
        }
      }), _c('div', {
        staticClass: "partiList"
      }, _vm._l(info.rowParticipantList, function (participant) {
        return _c('div', {
          key: participant.rtilCode,
          staticClass: "partiItem",
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return (() => {}).apply(null, arguments);
            }
          }
        }, [_c('el-checkbox', {
          on: {
            "change": val => {
              _vm.dealParticipantListUI({
                type: 'participantCheck',
                val,
                participant,
                partyCode: item.partyCode,
                index
              });
            }
          },
          model: {
            value: participant.checked,
            callback: function ($$v) {
              _vm.$set(participant, "checked", $$v);
            },
            expression: "participant.checked"
          }
        }), _c('span', [_vm._v(_vm._s(participant.nickName || participant.rtilCode))]), _c('i', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: participant.tagger,
            expression: "participant.tagger"
          }],
          staticClass: "iconfont icon-default1"
        })], 1);
      }), 0)], 1);
    }), 0)], 2);
  }), 1)], 1) : _c('div', {
    staticClass: "noDataContent"
  }, [_c('svg', {
    staticClass: "noDataSvg",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-a-undraw_no_data_re_kwbl1"
    }
  })]), _c('div', [_vm._v(_vm._s(_vm.$t('common.noGlobalData')))])])]), _c('div', {
    staticClass: "foot"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [12, 15, 20, 30],
      "page-size": 12,
      "layout": "prev, pager, next, sizes",
      "total": _vm.partyListInfo.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "prev-click": _vm.prevChange,
      "next-click": _vm.nextChange,
      "update:currentPage": function ($event) {
        _vm.currentPage = $event;
      },
      "update:current-page": function ($event) {
        _vm.currentPage = $event;
      }
    }
  })], 1)])]), _c('div', {
    staticClass: "contentRight"
  }, [_c('div', {
    staticClass: "right-Content"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('common.allFullScreen'),
      "placement": "top"
    }
  }, [_c('el-button', {
    staticClass: "fullscreen",
    class: {
      active: _vm.currentPartyInfo.fullScreen,
      gray: !_vm.GlobalControlId
    },
    attrs: {
      "disabled": !_vm.GlobalControlId,
      "type": "success"
    },
    on: {
      "click": function ($event) {
        return _vm.controlFullScreen('all');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('kioskHost.allFullScreen')))])], 1), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": _vm.$t('common.allOutFullScreen'),
      "placement": "top"
    }
  }, [_c('el-button', {
    staticClass: "unFullscreen",
    class: {
      active: !_vm.currentPartyInfo.fullScreen,
      gray: !_vm.GlobalControlId
    },
    attrs: {
      "disabled": !_vm.GlobalControlId,
      "type": "success"
    },
    on: {
      "click": function ($event) {
        return _vm.controlFullScreen('out');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('kioskHost.allOutFullScreen')))])], 1), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t('setting.settingName'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shezhi1",
    on: {
      "click": _vm.showSettingDialog
    }
  })])], 1), _c('el-divider', {
    staticClass: "rightDivider"
  }), _c('div', {
    staticClass: "mainWindow"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('kioskHost.toAllParty')))]), _vm.currentPartyInfo.id ? _c('MainWindowSelect', {
    ref: "mainWindowSelect",
    attrs: {
      "receiverNicknames": _vm.receiverNickname,
      "partyCode": _vm.partyCode,
      "showTitle": false,
      "partyInfo": _vm.currentPartyInfo,
      "nickNameInfo": _vm.behaviorInfo,
      "globalControlId": _vm.GlobalControlId,
      "mainWindowList": _vm.mainWindowList
    },
    on: {
      "callback": _vm.mainWindowSelectCallback
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "videoBox"
  }, [_c('NewAttendUser', {
    ref: "pgmBox",
    staticClass: "pgm is-pgm",
    attrs: {
      "theme": "danger",
      "singChannel": _vm.channels[_vm.currentPartyInfo.output],
      "showOperateBox": false,
      "showOperate": false,
      "muteAudio": _vm.muteAudioObj[_vm.currentPartyInfo.output],
      "title": _vm.currentPartyInfo.outputType === 'Receiver' ? 'VFB' : 'PGM',
      "nickName": _vm.currentPartyInfo.outputType === 'Receiver' ? 'VFB' : 'PGM',
      "outputRtilCode": _vm.currentPartyInfo.output + '',
      "showTitle": !_vm.currentPartyInfo.output ? false : true,
      "showMuteIcons": false,
      "rtc": _vm.rtc
    },
    on: {
      "callback": _vm.operateCallback
    }
  }, [!_vm.currentPartyInfo.output ? _c('div', {
    staticClass: "defaultUI"
  }, [_c('div', {
    staticClass: "contentBox"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoGray
    }
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('mainWindow.noSource')))]), _c('div', [_vm._v(_vm._s(_vm.$t('mainWindow.sourceFromWindow')))])])]) : _vm._e(), _vm.sourceType == 'Tag' && _vm.State.isTag == 1 && !_vm.currentPartyInfo.output ? _c('div', {
    staticClass: "defaultUI"
  }, [_c('div', {
    staticClass: "contentBox"
  }, [_c('div', {
    staticStyle: {
      "color": "#F1F1F1",
      "font-size": "16px",
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.$t('mainWindow.tagMainWindow')))])])]) : _vm._e()])], 1)], 1)]), _c('setting-dialog', {
    attrs: {
      "showSetting": _vm.settingPopupInfo.show
    },
    on: {
      "callback": _vm.closeSettingDialog
    }
  }), _vm.movePartyInfo.show ? _c('MovePartyList', {
    attrs: {
      "info": _vm.movePartyInfo,
      "userInfo": _vm.userInfo,
      "userInfoParty": true,
      "data": _vm.partyList
    },
    on: {
      "callback": _vm.moveCallback
    }
  }) : _vm._e(), _vm.globalControlInfoTips.show ? _c('TipsDailog', {
    staticClass: "globalControl",
    attrs: {
      "info": _vm.globalControlInfoTips,
      "notClose": true,
      "width": "550px"
    },
    on: {
      "save": _vm.saveControl,
      "cancel": function ($event) {
        _vm.globalName = '';
      }
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm.$t('kioskHost.controlName')))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#FF4B4B"
    }
  }, [_vm._v("*")]), _c('el-input', {
    staticClass: "editInput",
    class: {
      redBorder: _vm.showEmptyName
    },
    attrs: {
      "maxlength": 32
    },
    on: {
      "blur": _vm.blurName
    },
    model: {
      value: _vm.globalName,
      callback: function ($$v) {
        _vm.globalName = $$v;
      },
      expression: "globalName"
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showEmptyName,
      expression: "showEmptyName"
    }],
    staticStyle: {
      "color": "red",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.nameIsRequired')))]), _c('div', {
    staticClass: "partyListBox"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.mode')) + ":")]), _c('span', [_vm._v(_vm._s(_vm.$t('commonPartyHost.leftPane.title.kiosk')))])]), _c('div', {
    staticClass: "list scrollbar"
  }, _vm._l(_vm.kioskPartyList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "listLi",
      class: {
        disabled: item.belongToGlobalControl && !_vm.globalControlInfoTips.edit,
        hadSelect: _vm.returnClass(item)
      }
    }, [_c('div', {
      staticClass: "contentLeft"
    }, [item.title ? _c('p', {
      staticClass: "title",
      attrs: {
        "title": item.title
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('p', {
      staticClass: "title",
      attrs: {
        "title": new Date(item.createTime).toLocaleDateString() + '  ' + new Date(item.createTime).toLocaleTimeString()
      }
    }, [_vm._v(_vm._s(new Date(item.createTime).toLocaleDateString()) + " " + _vm._s(new Date(item.createTime).toLocaleTimeString()))]), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.$t('commonPartyHost.topContent.partyId')) + ": " + _vm._s(_vm._f("returnStrByInfo")(item.partyCode)))])]), _c('div', {
      staticClass: "contentRight"
    }, [_c('el-checkbox', {
      attrs: {
        "disabled": _vm.returnDisabled(item)
      },
      on: {
        "change": val => {
          _vm.savePartyInfo(val, item);
        }
      },
      model: {
        value: item.checked,
        callback: function ($$v) {
          _vm.$set(item, "checked", $$v);
        },
        expression: "item.checked"
      }
    })], 1)]);
  }), 0)]), _c('el-divider', {
    staticClass: "partyListDivider"
  }), _c('p', {
    staticClass: "select"
  }, [_vm._v(_vm._s(_vm.$t('kioskHost.partySelect')) + " " + _vm._s(_vm.returnNumber))])], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };